export default __webpack_public_path__ + "static/media/cc.6b7f8efc.svg";